/* eslint-disable no-restricted-globals */
import queryString from 'query-string';

export const queryParams = () => queryString.parse(location.search);
